import { useAuth } from "../../context/AuthContext";
import AppreciationWallTab from "../../components/profile/AppreciationWallTab";
import CreatorStudioLayout from "./CreatorStudioLayout";

export default function AppreciationWall() {
  const { currentUser } = useAuth();

  return (
    <CreatorStudioLayout activePath="/appreciation-wall">
      <div className="cs-page-eyebrow">Community</div>
      <h1 className="cs-page-title">Appreciation <em>Wall</em></h1>
      <p className="cs-page-sub">Messages from fans who appreciate your work.</p>
      <AppreciationWallTab creatorId={currentUser?.uid} isOwner />
    </CreatorStudioLayout>
  );
}
